import React, { useState } from 'react'
import {
  InfoAlert,
  LearnMoreBtn,
  AlertTitle,
  AlertDescription,
  RemoveIcon,
  EarnIcon,
} from './elements'

import earn from 'img/earn.svg'
import x from 'img/x.svg'
import rightArrow from 'img/icon-right.svg'
import {
  capturePosthogEvent,
  getFeatureFlag,
} from 'app/utils/iframe-communication'

const PAYMENT_ELIGIBILITY_BANNER_DISMISSED =
  'payment_eligibility_banner_dismissed'

const LEARN_MORE_URL =
  'https://mozio.notion.site/Mozio-Bi-Weekly-Payment-Criteria-1a85cb3b82278007b9b2f48682c4b13a?pvs=4'

export const FeatureFlagAlert = () => {
  const shouldShowBanner = !localStorage.getItem(
    PAYMENT_ELIGIBILITY_BANNER_DISMISSED
  )
  const [showBanner, setShowBanner] = useState(shouldShowBanner)

  if (!getFeatureFlag('payment_eligibility_banner')) {
    return null
  }

  if (!showBanner) {
    return null
  }

  const onDismissBanner = () => {
    localStorage.setItem(PAYMENT_ELIGIBILITY_BANNER_DISMISSED, '1')
    setShowBanner(false)
  }

  const captureLearnMoreClick = () => {
    capturePosthogEvent('payment_eligibility_banner_learn_more_clicked')
  }

  return (
    <InfoAlert>
      <EarnIcon src={earn} alt="earn" />
      <div>
        <AlertTitle>Get Paid Faster!</AlertTitle>
        <AlertDescription>
          Providers who maintain excellent quality and track compliance using
          the Mozio Driver App may qualify for bi-weekly payments.
          <br /> <br />
          Want to see how you&#39;re doing? Head over to the{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              window.parent.postMessage(
                {
                  type: 'NAVIGATE',
                  payload: {
                    path: '/providers-dashboard/reports',
                  },
                },
                '*'
              )
            }}
          >
            Reports page
          </a>{' '}
          to check your performance.
        </AlertDescription>
        <LearnMoreBtn
          href={LEARN_MORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={captureLearnMoreClick}
        >
          Learn more: Eligibility Criteria{' '}
          <img src={rightArrow} alt="arrow-right" />
        </LearnMoreBtn>
      </div>
      <RemoveIcon src={x} alt="x" onClick={onDismissBanner} />
    </InfoAlert>
  )
}
